interface Properties {
  width?: number;
  height?: number;
  color?: string;
}

/** Figma 75644:18056 — scenario ("Baseline") pill branch icon. */
const FigmaScenarioBranchIcon = ({ width = 14, height = 14, color = '#8B5CF6' }: Properties) => (
  <svg
    width={width}
    height={height}
    viewBox='0 0 13.3333 13.3333'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M12.6667 4.66667C12.2667 4.66667 12 4.4 12 4V1.33333H9.33333C8.93333 1.33333 8.66667 1.06667 8.66667 0.666667C8.66667 0.266667 8.93333 0 9.33333 0H12.6667C13.0667 0 13.3333 0.266667 13.3333 0.666667V4C13.3333 4.4 13.0667 4.66667 12.6667 4.66667Z'
      fill={color}
    />
    <path
      d='M0.666667 4.66667C0.266667 4.66667 0 4.4 0 4V0.666667C0 0.266667 0.266667 0 0.666667 0H4C4.4 0 4.66667 0.266667 4.66667 0.666667C4.66667 1.06667 4.4 1.33333 4 1.33333H1.33333V4C1.33333 4.4 1.06667 4.66667 0.666667 4.66667Z'
      fill={color}
    />
    <path
      d='M6.66667 13.3333C6.26667 13.3333 6 13.0667 6 12.6667V8.06667C6 7 6.4 6 7.2 5.26667L12.2 0.266667C12.4667 5.76178e-08 12.8667 5.76178e-08 13.1333 0.266667C13.4 0.533333 13.4 0.933333 13.1333 1.2L8.13333 6.2C7.6 6.66667 7.33333 7.33333 7.33333 8.06667V12.6667C7.33333 13.0667 7.06667 13.3333 6.66667 13.3333Z'
      fill={color}
    />
    <path
      d='M6.66667 9.33333C6.26667 9.33333 6 9.06667 6 8.66667V8.06667C6 7.33333 5.73333 6.66667 5.2 6.2L0.2 1.13333C-0.0666667 0.866667 -0.0666667 0.466667 0.2 0.2C0.466667 -0.0666667 0.866667 -0.0666667 1.13333 0.2L6.13333 5.2C6.86667 5.93333 7.33333 6.93333 7.33333 8V8.66667C7.33333 9.06667 7.06667 9.33333 6.66667 9.33333Z'
      fill={color}
    />
  </svg>
);

export default FigmaScenarioBranchIcon;
